<template lang="pug">
.bar-grafico
    BarraGrafico(type='BarChart', :data='dados', :options='options')
</template>

<script>
import { GChart as BarraGrafico } from 'vue-google-charts/legacy';

export default {
    name: 'GraficoBarra',
    props: {
        dados: {
            type: Array,
            default: () => []
        }
    },
    components: {
        BarraGrafico
    },
    data() {
        return {
            options: {
                chartArea: { width: '50%', height: '78%' },
                hAxis: {
                    minValue: 0
                },
                legend: { position: 'bottom', maxLines: 3 },
                animation: {
                    duration: 1000,
                    easing: 'out',
                    startup: true
                },
                colors: ['#043c5a'],
                width: 430,
                height: 460
            }
        };
    }
};
</script>
